import { Space, Table } from 'antd';
import { useContext } from 'react';
import { PageContext } from '../../../lib/context';
import CreateDrawer from '../../../components/create';
import AdditionalFeesForm from './form';
import Loading from '../../../components/loader';

const AdditionalFeesView = () => {
  const { _submitHandler, columns, addFees, loading } = useContext(PageContext);

  return (
    <div className="flex flex-col px-10 place">
      <div className="items-start align-start">
        <p className="text-3xl font-bold">Additional Fees</p>
      </div>
      <Space>
        <CreateDrawer
          title="Create Additional Fees"
          _submitHandler={_submitHandler}
          addForm={true}
        >
          <AdditionalFeesForm />
        </CreateDrawer>
      </Space>
      <div className="flex flex-row mt-5">
        <div className="w-full mr-3">
          {loading ? (
            <div className="mt-32">
              <Loading show={loading} />
            </div>
          ) : (
            <Table dataSource={addFees} columns={columns} />)
          }
        </div>
      </div>
    </div>
  );
};

export default AdditionalFeesView;
